module.exports = '1.6.1';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 203
// module chunks = 0